<script lang="ts">
    import { STATUS } from "@/constants/statuses";
    import ReviewEntity from "@apps/reviews/entities/ReviewEntity";
    import { ReviewTranslationResponseEntity } from "@apps/reviews/entities/ReviewTranslationEntity";

    import ReviewItemContainer from "../ReviewItemContainer.svelte";
    import ReviewItem from "./ReviewItem/ReviewItem.svelte";
    import ReviewItemSkeleton from "./ReviewItem/ReviewItemSkeleton.svelte";

    export let reviews: ReviewEntity[];
    export let status: STATUS;
    export let reviewsTranslations: ReviewTranslationResponseEntity[] = [];
    export let translationsPendingIds: number[] = [];
    export let translationEnabled = false;
    export let showTitle: boolean;
    export let showProducts: boolean;
    export let votesEnabled: boolean;
    export let namespace: string;
    export let isIncentivizedEnabled: boolean;
    export let currentProductId: number | null | undefined = undefined;

    $: showSkeleton = [STATUS.VIRGIN, STATUS.INITIAL_LOADING].includes(status);
</script>

<div class="gw-rv-list">
    {#if showSkeleton}
        <ReviewItemSkeleton />
    {:else}
        {#each reviews as review (review.id)}
            <div class="gw-rv-list__item-wrapper">
                <ReviewItemContainer
                    {review}
                    reviewsTranslation={reviewsTranslations.find(
                        (t) => t.reviewId === review.id
                    ) || null}
                    {translationsPendingIds}
                    {namespace}
                    on:seeTranslation
                    on:openReview
                    let:props
                >
                    <ReviewItem
                        {namespace}
                        {review}
                        {translationEnabled}
                        translsatedContent={props.translsatedContent}
                        showTranslation={props.showTranslation}
                        isTranslationLoading={props.isTranslationLoading}
                        {showTitle}
                        {showProducts}
                        {votesEnabled}
                        {isIncentivizedEnabled}
                        reviewVotes={props.reviewVotes}
                        customerName={props.customerName}
                        {currentProductId}
                        on:openReview={props.handleOpenReview}
                        on:toggleVote={props.handleToggleVote}
                        on:seeTranslation={props.handleSeeTranslation}
                    />
                </ReviewItemContainer>
            </div>
        {/each}
    {/if}
</div>

<style>
    .gw-rv-list {
        --product-title-max-width: 90%;

        display: flex;
        flex-direction: column;
        gap: 20px;
    }
</style>
